/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/display-name */
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React from "react";
import PropTypes from "prop-types";
import ContentTag from "../ContentTag";

const VideoFooter = React.forwardRef(
  // eslint-disable-next-line no-unused-vars
  ({ videoDetails, onClick, printableMediaCard, shareContentButton }, ref) => (
    <div className="pb-md pt-0">
      <div className="flex flex-row w-full justify-between items-center mb-md bg-white py-sm px-sm rounded-br rounded-bl min-h-video-title">
        <div className="flex flex-col md:flex-row w-4/6 gap-xs lg:gap-sm mr-sm items-start md:items-center">
          {videoDetails.icon ? (
            // eslint-disable-next-line @next/next/no-img-element
            <img
              className="w-xl h-auto hidden md:block"
              src={videoDetails.icon}
              alt={videoDetails.description}
            />
          ) : null}

          <div className="flex flex-col justify-center">
            <h3 className="gn-video-title font-bold text-black">
              {videoDetails.title}
            </h3>
            {/* TODO: Update to pull real data for Channel Name  */}
            {/* {videoDetails.channelName ? (
            <p className="gn-text-xs text-gray-200">
              from{" "}
              <a href="/" className="hover:text-mint">
                {videoDetails.channelName}
              </a>
            </p>
            ) : null} */}
          </div>
        </div>

        {videoDetails.sponsorIcon ? (
          <div ref={ref} className="w-2/6 lg:w-screen-xs px-xs">
            <p className="flex flex-col lg:flex-row justify-end items-center gap-xs gn-text-xs font-bold text-black uppercase">
              Powered by{" "}
              <a
                href={videoDetails.partnerUrl}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className="w-2xl px-sm"
                  src={videoDetails.sponsorIcon}
                  alt={videoDetails.partnerName}
                />
              </a>
            </p>
          </div>
        ) : null}
      </div>
      <div className="flex flex-col lg:flex-row px-sm">
        <div className="w-full lg:w-3/5">
          <div className="gn-text-sm text-white lg:pr-xl mb-md">
            {videoDetails.description}
          </div>
          <div className="mb-md">
            {videoDetails.contentTags.map(({ id, name, slug }) => (
              <ContentTag
                key={id}
                text={name}
                slug={slug}
                onClick={() => onClick(id, slug)}
              />
            ))}
          </div>
        </div>
        {videoDetails.printable ? (
          <div className="w-full lg:w-2/5">{printableMediaCard}</div>
        ) : null}
      </div>
      <div className="pl-sm pt-md lg:pt-0">{shareContentButton}</div>
    </div>
  ),
);

VideoFooter.propTypes = {
  videoDetails: PropTypes.shape({
    contentTags: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
      }),
    ),
    icon: PropTypes.string,
    sponsorIcon: PropTypes.string,
    partnerUrl: PropTypes.string,
    partnerName: PropTypes.string,
    description: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    channelName: PropTypes.string.isRequired,
    printable: PropTypes.object,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  printableMediaCard: PropTypes.object,
  shareContentButton: PropTypes.object,
};

export default VideoFooter;
